import React, { useState, useEffect } from 'react';

const LocalizedDatetime = () => {
  const [dateTime, setDateTime] = useState(new Date());

  useEffect(() => {
    // Update every second
    const timer = setInterval(() => {
      setDateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Method 1: Using Intl.DateTimeFormat (most customizable)


  // Method 3: Using toLocaleDateString and toLocaleTimeString separately
  const dateOnly = dateTime.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const timeOnly = dateTime.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });

  return (
    <div className="space-y-4">
      <div className="p-4 bg-transparent rounded-lg">
        <p className="text-gray-900 font-semibold">{dateOnly}</p>
        <p className="text-gray-700">{timeOnly}</p>
      </div>
    </div>
  );
};

export default LocalizedDatetime;